function f(e, t) {
  for (var n = -1, h = t.length, r = e.length; ++n < h; )
    e[r + n] = t[n];
  return e;
}
var g = f;
export {
  g as _
};
